import {translate} from 'views/module';

import {generateFilterOptions} from '../../list/scene/filter/FilterGenerator';

const generateLoomFilterOptions = () => {
  const filterOptions = generateFilterOptions();

  filterOptions.status = {
    ...filterOptions.status,
    options: Object.entries(translate('caregiver.LoomStatus'))
        .reduce((acc, [key, value], index) => {
          acc[key] = {
            label: value.Title,
            color: value.Color,
            rank: index,
            key: key,
          };
          return acc;
        }, {}),
    defaultSelected: ['ACTIVE', 'IN_REVIEW'],
  };

  return filterOptions;
};

export {
  generateLoomFilterOptions,
};
